import dayjs from 'dayjs';
import { motion } from 'framer-motion';
import { FiFileText } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { NoteAddedNotificationType } from '../../types/notifications';
import { LIST_ITEM_ANIMATIONS } from '../consts/motionAnimations';

type NoteAddedWidgetNotificationCardProps = {
  notificationDetails: NoteAddedNotificationType;
  onClick: (id: number) => void;
};

const NoteAddedWidgetNotificationCard = ({ notificationDetails, onClick }: NoteAddedWidgetNotificationCardProps) => {
  const { t } = useTranslation();
  const timeAgo = (iso: string) => dayjs(iso).fromNow();

  return (
    <motion.li key={notificationDetails.notificationId} className="overflow-hidden" {...LIST_ITEM_ANIMATIONS}>
      <div className="group flex flex-col px-4 py-3 hover:bg-slate-50 cursor-pointer">
        <div
          onClick={() => onClick(notificationDetails.notificationId)}
          className="flex w-full items-start gap-3 text-left"
        >
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-100 text-blue-600">
            <FiFileText fontSize={16} />
          </div>

          <div className="min-w-0 flex-1">
            <div className="flex items-baseline justify-between">
              <p className="truncate text-sm font-semibold text-slate-800">{notificationDetails.title}</p>
              <time className="ml-2 flex-shrink-0 text-xs text-slate-500">
                {timeAgo(notificationDetails.createdAt)}
              </time>
            </div>
            <p className="mt-1 text-xs text-slate-600 line-clamp-2">{notificationDetails.message}</p>

            {!notificationDetails.isRead && (
              <div className="mt-2 flex items-center gap-2">
                <div className="h-2 w-2 rounded-full bg-blue-500" aria-label={t('notifications-new-badge')} />
              </div>
            )}
          </div>
        </div>
      </div>
    </motion.li>
  );
};

export default NoteAddedWidgetNotificationCard;
